module.exports = __webpack_public_path__ + "img/every1.e60d9ad8.svg";